module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VqzWvt/tc-custom/9781646564514.jpg?1723405516456",
      "alt": "This image is the cover for the book Jack's Back, Indiscreet"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jack's Back, Indiscreet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Jim Menetti had a life at Indiscreet, the Gay BDSM club owned by Bear Drummond and Reed Davis. His life revolves around Reed, his Master, and his position as manager of the Club."), _c('br'), _c('br'), _vm._v("On Jim and Reed's third anniversary, Jack Leary, Reed's on and off flame comes back and Jim's relationship with Reed unravels."), _c('br'), _c('br'), _vm._v("He picks himself up and makes a life for himself apart from his job, buys a home, makes it into a cozy retreat, and gets a cat he names Waltzing Matilda. He even has a new love interest, the mysterious Professor Caleb Brickner, an expert in the Spanish Inquisition and medieval torture."), _c('br'), _c('br'), _vm._v("Then Reed changes his mind.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A.C. Katt\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0